<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Control de Cargues</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item active">Argentina</li>
                  <li class="breadcrumb-item active">Operación</li>
                  <li class="breadcrumb-item active">Control de Cargues</li>
                </ol>
              </div>
            </div>
          </div>
        </section>

        <section class="content">
          <div class="container-fluid">
            <!-- Formulario Principal -->
            <div class="card">
              <div
                class="card-header alert-default-primary py-2 position-relative"
              >
                <h3 class="card-title mb-0" style="font-size: 1.1rem">
                  <i class="fas fa-clipboard-check mr-2"></i>
                  Datos del Control de Cargue
                </h3>
                <div class="card-tools">
                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="collapse"
                    data-toggle="tooltip"
                    title="Minimizar"
                  >
                    <i class="fas fa-minus"></i>
                  </button>
                  <!-- <button
                    v-if="
                      $store.getters.can(
                        'argentina.controlCargues.asignarRemitos'
                      )
                    "
                    type="button"
                    class="btn btn-primary btn-sm"
                    @click="abrirModalAsignarRemitos()"
                  >
                    <i class="fas fa-user-tag mr-1"></i>
                    Asignar Remitos por Rol
                  </button> -->
                </div>
              </div>
              <div class="card-body pb-2">
                <!-- SECCIÓN 1: Información General -->
                <div class="card card-outline card-info mb-3">
                  <div class="card-header card-header-corner py-1 bg-light">
                    <h6 class="card-title mb-0 font-weight-bold text-info">
                      <i class="fas fa-info-circle mr-1"></i>
                      Información General
                    </h6>
                    <div class="card-tools">
                      <button
                        type="button"
                        class="btn btn-tool btn-sm"
                        data-card-widget="collapse"
                        data-toggle="tooltip"
                        title="Minimizar"
                      >
                        <i class="fas fa-minus"></i>
                      </button>
                    </div>
                  </div>
                  <div class="card-body py-2">
                    <div class="row">
                      <div class="col-md-3">
                        <div class="form-group mb-2">
                          <label class="mb-1">
                            <i class="fas fa-file-alt mr-1"></i>
                            Fecha Inicial
                          </label>
                          <input
                            type="date"
                            class="form-control form-control-sm"
                            v-model="formulario.fecha_ini"
                          />
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="form-group mb-2">
                          <label class="mb-1">
                            <i class="fas fa-file-alt mr-1"></i>
                            Hora Inicial
                          </label>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            v-model="formulario.hora_ini"
                            v-mask="{
                              mask: '99:99',
                              hourFormat: '24',
                            }"
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group mb-2">
                          <label class="mb-1">
                            <i class="fas fa-file-alt mr-1"></i>
                            Fecha Final
                          </label>
                          <input
                            type="date"
                            class="form-control form-control-sm"
                            v-model="formulario.fecha_fin"
                          />
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="form-group mb-2">
                          <label class="mb-1">
                            <i class="fas fa-file-alt mr-1"></i>
                            Hora Final
                          </label>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            v-model="formulario.hora_fin"
                            v-mask="{
                              mask: '99:99',
                              hourFormat: '24',
                            }"
                          />
                        </div>
                      </div>
                      <div class="col-md-2 mt-2 pt-3">
                        <div class="form-group mb-2">
                          <button
                            type="button"
                            class="btn btn-primary btn-sm"
                            @click="buscar()"
                            v-if="formulario.fecha_ini && formulario.fecha_fin"
                          >
                            <i class="fas fa-search-plus mr-1"></i>
                            Calcular Rangos
                          </button>
                        </div>
                      </div>
                    </div>
                    <hr class="w-100" />
                    <div class="row">
                      <div class="col-md-3">
                        <div class="form-group mb-2">
                          <label class="mb-1">
                            <i class="fas fa-file-alt mr-1"></i>
                            Hoja de Carga
                          </label>
                          <v-select
                            v-model="formulario.hoja_carga"
                            placeholder="Seleccione hoja de carga..."
                            :get-option-label="labelHojaCarga"
                            class="style-chooser"
                            :options="hojasCarga"
                            @input="onHojaCargaChange"
                            @search="cargarHojasCarga"
                          >
                            <template #option="option">
                              <div>
                                <div class="font-weight-bold">
                                  Remito N° {{ option.remito.numero }} -
                                  {{ option.fecha }}
                                </div>
                                <small class="text-muted">
                                  {{
                                    option.cliente
                                      ? option.cliente.razon_social
                                      : "Sin cliente"
                                  }}
                                  |
                                  {{
                                    option.chofer
                                      ? `${option.chofer.nombres} ${option.chofer.apellidos}`
                                      : "Sin chofer"
                                  }}
                                </small>
                              </div>
                            </template>
                          </v-select>
                        </div>
                      </div>

                      <div class="col-md-2">
                        <div class="form-group mb-2">
                          <label class="mb-1">
                            <i class="far fa-calendar mr-1"></i>
                            Fecha
                          </label>
                          <input
                            type="date"
                            class="form-control form-control-sm"
                            v-model="formulario.fecha"
                          />
                        </div>
                      </div>

                      <div class="col-md-2">
                        <div class="form-group mb-2">
                          <label class="mb-1">
                            <i class="far fa-clock mr-1"></i>
                            Hora Inicial
                          </label>
                          <input
                            type="time"
                            class="form-control form-control-sm"
                            v-model="formulario.hora_inicial"
                          />
                        </div>
                      </div>

                      <div class="col-md-2">
                        <div class="form-group mb-2">
                          <label class="mb-1">
                            <i class="far fa-clock mr-1"></i>
                            Hora Final
                          </label>
                          <input
                            type="time"
                            class="form-control form-control-sm"
                            v-model="formulario.hora_final"
                          />
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="form-group mb-2">
                          <label class="mb-1">
                            <i class="fas fa-map-marker-alt mr-1"></i>
                            Sitio / Isla
                          </label>
                          <v-select
                            v-model="formulario.sitio"
                            placeholder="Seleccione sitio..."
                            label="nombre"
                            class="style-chooser"
                            :options="sitios"
                          ></v-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- SECCIÓN 2: Datos del Cliente y Transporte -->
                <div class="card card-outline card-primary mb-3">
                  <div class="card-header card-header-corner py-1 bg-light">
                    <h6 class="card-title mb-0 font-weight-bold text-primary">
                      <i class="fas fa-truck-loading mr-1"></i>
                      Cliente y Transporte
                    </h6>
                    <div class="card-tools">
                      <button
                        type="button"
                        class="btn btn-tool btn-sm"
                        data-card-widget="collapse"
                        data-toggle="tooltip"
                        title="Minimizar"
                      >
                        <i class="fas fa-minus"></i>
                      </button>
                    </div>
                  </div>
                  <div class="card-body py-2">
                    <div class="row">
                      <div class="col-md-3">
                        <div class="form-group mb-2">
                          <label class="mb-1">
                            <i class="fas fa-building mr-1"></i>
                            Cliente
                          </label>
                          <v-select
                            v-model="formulario.cliente"
                            placeholder="Seleccione cliente..."
                            label="razon_social"
                            class="style-chooser"
                            :options="clientes"
                          ></v-select>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="form-group mb-2">
                          <label class="mb-1">
                            <i class="fas fa-truck mr-1"></i>
                            Empresa Transporte
                          </label>
                          <v-select
                            v-model="formulario.transporte"
                            placeholder="Seleccione transporte..."
                            label="razon_social"
                            class="style-chooser"
                            :options="transportes"
                          ></v-select>
                        </div>
                      </div>

                      <div class="col-md-4">
                        <div class="form-group mb-2">
                          <label class="mb-1">
                            <i class="fas fa-user mr-1"></i>
                            Conductor
                          </label>
                          <v-select
                            v-model="formulario.conductor"
                            placeholder="Buscar por nombre o documento..."
                            :filter-by="buscarConductor"
                            :get-option-label="labelConductor"
                            class="style-chooser"
                            :options="conductores"
                            @input="onConductorChange"
                          >
                            <template #option="option">
                              <div class="d-flex justify-content-between">
                                <span>{{ labelConductor(option) }}</span>
                                <small class="text-muted">{{
                                  option.numero_documento ||
                                    option.documento ||
                                    option.cedula
                                }}</small>
                              </div>
                            </template>
                          </v-select>
                        </div>
                      </div>

                      <div class="col-md-2">
                        <div class="form-group mb-2">
                          <label class="mb-1">
                            <i class="fas fa-id-card mr-1"></i>
                            Documento
                          </label>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            v-model="formulario.documento"
                            placeholder="N° Documento"
                            readonly
                            style="background-color: #e9ecef"
                          />
                        </div>
                      </div>

                      <div class="col-md-2">
                        <div class="form-group mb-2">
                          <label class="mb-1">
                            <i class="fas fa-file-invoice mr-1"></i>
                            Remito
                          </label>
                          <v-select
                            v-model="formulario.remito"
                            placeholder="Seleccione remito..."
                            label="numero_formateado"
                            class="style-chooser"
                            :options="remitos"
                          ></v-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <!-- SECCIÓN 3: Datos de Carga -->
                  <div class="col-md-6">
                    <div class="card card-outline card-success mb-3">
                      <div class="card-header card-header-corner py-1 bg-light">
                        <h6
                          class="card-title mb-0 font-weight-bold text-success"
                        >
                          <i class="fas fa-tint mr-1"></i>
                          Datos de Carga
                        </h6>
                        <div class="card-tools">
                          <button
                            type="button"
                            class="btn btn-tool btn-sm"
                            data-card-widget="collapse"
                            data-toggle="tooltip"
                            title="Minimizar"
                          >
                            <i class="fas fa-minus"></i>
                          </button>
                        </div>
                      </div>
                      <div class="card-body py-2">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group mb-2">
                              <label class="mb-1 font-weight-bold">
                                <i class="fas fa-tint mr-1"></i>
                                Vol. Cargado (Lts)
                              </label>
                              <input
                                type="number"
                                step="0.001"
                                class="form-control form-control-sm"
                                v-model.number="formulario.vol_cargado"
                                placeholder="0.000"
                                @input="onVolCargadoChange"
                              />
                            </div>
                          </div>

                          <div class="col-md-6">
                            <div class="form-group mb-2">
                              <label class="mb-1">
                                <i class="fas fa-oil-can mr-1"></i>
                                Vol. Oil Hidratado (Lts)
                              </label>
                              <input
                                type="number"
                                step="0.001"
                                class="form-control form-control-sm bg-light"
                                v-model.number="formulario.vol_oil_hidratado"
                                placeholder="0.000"
                                readonly
                              />
                            </div>
                          </div>

                          <div class="col-md-12">
                            <div class="form-group mb-2">
                              <label class="mb-1 font-weight-bold">
                                <i class="fas fa-thermometer-half mr-1"></i>
                                Temperatura TK/MAS (°C)
                              </label>
                              <input
                                type="number"
                                step="0.01"
                                class="form-control form-control-sm"
                                v-model.number="formulario.temp_tk_mas"
                                placeholder="0.00"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- SECCIÓN 4: Datos de Laboratorio -->
                  <div class="col-md-6">
                    <div class="card card-outline card-warning mb-3">
                      <div class="card-header card-header-corner py-1 bg-light">
                        <h6
                          class="card-title mb-0 font-weight-bold text-warning"
                        >
                          <i class="fas fa-flask mr-1"></i>
                          Datos de Laboratorio
                        </h6>
                        <div class="card-tools">
                          <button
                            type="button"
                            class="btn btn-tool btn-sm"
                            data-card-widget="collapse"
                            data-toggle="tooltip"
                            title="Minimizar"
                          >
                            <i class="fas fa-minus"></i>
                          </button>
                        </div>
                      </div>
                      <div class="card-body py-2">
                        <div class="row">
                          <div class="col-md-4">
                            <div class="form-group mb-2">
                              <label class="mb-1 font-weight-bold">
                                % Agua
                              </label>
                              <input
                                type="number"
                                step="0.01"
                                class="form-control form-control-sm"
                                v-model.number="formulario.porcentaje_agua"
                                placeholder="0.00"
                              />
                            </div>
                          </div>

                          <div class="col-md-4">
                            <div class="form-group mb-2">
                              <label class="mb-1 font-weight-bold">
                                Densidad
                              </label>
                              <input
                                type="number"
                                step="0.001"
                                class="form-control form-control-sm"
                                v-model.number="formulario.densidad"
                                placeholder="0.000"
                              />
                            </div>
                          </div>

                          <div class="col-md-4">
                            <div class="form-group mb-2">
                              <label class="mb-1 font-weight-bold">
                                T° Muestra (°C)
                              </label>
                              <input
                                type="number"
                                step="0.1"
                                class="form-control form-control-sm"
                                v-model.number="formulario.t_muestra"
                                placeholder="0.0"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- SECCIÓN 5: Volumen Másico -->
                <div class="card card-outline card-primary mb-0">
                  <div class="card-header card-header-corner py-1 bg-primary">
                    <h6 class="card-title mb-0 text-white font-weight-bold">
                      <i class="fas fa-chart-bar mr-1"></i>
                      VOLUMEN MÁSICO
                    </h6>
                    <div class="card-tools">
                      <button
                        type="button"
                        class="btn btn-tool btn-sm text-white"
                        data-card-widget="collapse"
                        data-toggle="tooltip"
                        title="Minimizar"
                      >
                        <i class="fas fa-minus"></i>
                      </button>
                    </div>
                  </div>
                  <div class="card-body py-2">
                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-group mb-2">
                          <label class="mb-1 font-weight-bold">
                            <i class="fas fa-arrow-down mr-1"></i>
                            Volumen Inicial (m³)
                          </label>
                          <input
                            type="number"
                            step="0.001"
                            class="form-control form-control-sm font-weight-bold"
                            v-model.number="formulario.volumen_inicial"
                            placeholder="0.000"
                          />
                        </div>
                      </div>

                      <div class="col-md-4">
                        <div class="form-group mb-2">
                          <label class="mb-1 font-weight-bold">
                            <i class="fas fa-arrow-up mr-1"></i>
                            Vol. Final (m³)
                          </label>
                          <input
                            type="number"
                            step="0.001"
                            class="form-control form-control-sm font-weight-bold"
                            v-model.number="formulario.volumen_final"
                            placeholder="0.000"
                          />
                        </div>
                      </div>

                      <div class="col-md-4">
                        <div class="form-group mb-2">
                          <label class="mb-1 font-weight-bold text-success">
                            <i class="fas fa-equals mr-1"></i>
                            Vol. Cargado (m³)
                          </label>
                          <input
                            type="number"
                            step="0.001"
                            class="form-control form-control-sm font-weight-bold text-success bg-light"
                            style="background-color: #d4edda !important"
                            :value="volumenCargadoM3"
                            readonly
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer py-2">
                <div class="d-flex justify-content-between align-items-center">
                  <button
                    type="button"
                    class="btn btn-secondary btn-sm"
                    @click="limpiarFormulario()"
                  >
                    <i class="fas fa-broom mr-1"></i>
                    Limpiar
                  </button>
                  <button
                    type="button"
                    class="btn btn-success btn-sm"
                    data-toggle="modal"
                    data-target="#modal-seguimientos-cargues"
                    @click="$refs.seguimientoCargueExcel.limpiarModal()"
                  >
                    <i class="fas fa-file-excel mr-1"></i>
                    Seguimientos de Cargues
                  </button>
                  <button
                    type="button"
                    class="btn btn-success btn-lg"
                    :disabled="!formulario.sitio"
                    @click="calcular()"
                  >
                    <i class="fas fa-calculator mr-2"></i>
                    CALCULAR
                  </button>
                </div>
              </div>
            </div>

            <!-- Tabla de Resultados -->
            <div class="card" v-if="resultados.length > 0">
              <div
                class="card-header card-header-corner py-2"
                style="
                  background-color: #f8f9fa;
                  border-bottom: 2px solid #dee2e6;
                "
              >
                <h3
                  class="card-title mb-0"
                  style="font-size: 1.1rem; color: #495057"
                >
                  <i class="fas fa-table mr-2"></i>
                  Resultados Calculados
                </h3>
                <div class="card-tools">
                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="collapse"
                    data-toggle="tooltip"
                    title="Minimizar"
                  >
                    <i class="fas fa-minus"></i>
                  </button>
                </div>
              </div>
              <div class="card-body p-0">
                <div class="table-container">
                  <table
                    class="table table-bordered table-hover table-sm mb-0 custom-table"
                  >
                    <thead>
                      <!-- Fila de grupos -->
                      <tr c>
                        <!-- Datos Básicos -->
                        <th
                          class="text-center align-middle sticky-col"
                          rowspan="2"
                        >
                          Fecha
                        </th>
                        <th class="text-center align-middle" rowspan="2">
                          Hora Inicial
                        </th>
                        <th class="text-center align-middle" rowspan="2">
                          Hora Final
                        </th>
                        <th class="text-center align-middle" rowspan="2">
                          Cliente
                        </th>
                        <th class="text-center align-middle" rowspan="2">
                          Transporte
                        </th>
                        <th class="text-center align-middle" rowspan="2">
                          Conductor
                        </th>
                        <th class="text-center align-middle" rowspan="2">
                          Documento
                        </th>
                        <th class="text-center align-middle" rowspan="2">
                          N° Carga
                        </th>
                        <th class="text-center align-middle" rowspan="2">
                          Remito
                        </th>
                        <th class="text-center align-middle" rowspan="2">
                          Sitio
                        </th>
                        <!-- Volúmenes de Carga -->
                        <th
                          class="text-center align-middle header-carga"
                          rowspan="2"
                        >
                          Vol. Cargado<br />(Lts)
                        </th>
                        <th
                          class="text-center align-middle header-carga"
                          rowspan="2"
                        >
                          Temp. TK/MAS<br />(°C)
                        </th>
                        <!-- Datos de Laboratorio -->
                        <th
                          class="text-center align-middle header-laboratorio"
                          rowspan="2"
                        >
                          % Agua
                        </th>
                        <th
                          class="text-center align-middle header-laboratorio"
                          rowspan="2"
                        >
                          Dens.
                        </th>
                        <th
                          class="text-center align-middle header-laboratorio"
                          rowspan="2"
                        >
                          T° Muestra<br />(°C)
                        </th>
                        <th
                          class="text-center align-middle header-laboratorio"
                          rowspan="2"
                        >
                          Sales<br />(Gr/m³)
                        </th>
                        <!-- Datos Adicionales -->
                        <th class="text-center align-middle" rowspan="2">
                          N° PEDIDO
                        </th>
                        <th class="text-center align-middle" rowspan="2">
                          SAP
                        </th>
                        <!-- Resultados Calculados -->
                        <th
                          class="text-center align-middle header-resultado"
                          rowspan="2"
                        >
                          Vol. Oil Hidratado<br />
                          (Lts)
                        </th>
                        <th
                          class="text-center align-middle header-resultado"
                          rowspan="2"
                        >
                          Temp. TK/MAS<br />(°C)
                        </th>
                        <th
                          class="text-center align-middle header-resultado"
                          rowspan="2"
                        >
                          F. Corrección
                        </th>
                        <th
                          class="text-center align-middle header-resultado"
                          rowspan="2"
                        >
                          Vol. Agua y<br />Sedimento (m³)
                        </th>
                        <th
                          class="text-center align-middle header-resultado"
                          rowspan="2"
                        >
                          Vol. Total Final<br />Seco (Lts)
                        </th>
                        <th
                          class="text-center align-middle header-resultado"
                          rowspan="2"
                        >
                          Gravedad API
                        </th>
                        <!-- Volumen Másico - Grupo -->
                        <th
                          class="text-center align-middle header-masico"
                          colspan="3"
                        >
                          VOLUMEN MÁSICO
                        </th>
                        <!-- Acciones -->
                        <th class="text-center align-middle" rowspan="2">
                          Acciones
                        </th>
                      </tr>
                      <!-- Fila de subencabezados -->
                      <tr>
                        <!-- Volumen Másico - Subencabezados -->
                        <th class="text-center align-middle header-masico">
                          Inicial<br />(m³)
                        </th>
                        <th class="text-center align-middle header-masico">
                          Final<br />(m³)
                        </th>
                        <th class="text-center align-middle header-masico">
                          Cargado<br />(m³)
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(resultado, index) in resultados" :key="index">
                        <!-- Datos Básicos -->
                        <td class="text-center sticky-col">
                          {{ resultado.fecha }}
                        </td>
                        <td class="text-center">
                          {{ resultado.hora_inicio }}
                        </td>
                        <td class="text-center">{{ resultado.hora_final }}</td>
                        <td>
                          {{
                            resultado.cliente
                              ? resultado.cliente.razon_social
                              : "-"
                          }}
                        </td>
                        <td>
                          {{
                            resultado.empresa
                              ? resultado.empresa.razon_social
                              : "-"
                          }}
                        </td>
                        <td>
                          {{
                            resultado.chofer
                              ? labelConductor(resultado.chofer)
                              : "-"
                          }}
                        </td>
                        <td class="text-center">
                          {{ resultado.chofer.numero_documento || "-" }}
                        </td>
                        <td class="text-center">
                          {{ resultado.numero_carga }}
                        </td>
                        <td class="text-center">
                          {{
                            resultado.remito
                              ? resultado.remito.numero_formateado
                              : "-"
                          }}
                        </td>
                        <td class="text-center">
                          <span
                            class="badge badge-secondary"
                            style="background-color: #6c757d"
                          >
                            {{ resultado.isla ? resultado.isla.nombre : "-" }}
                          </span>
                        </td>
                        <!-- Volúmenes de Carga -->
                        <td class="text-right font-weight-bold">
                          {{ resultado.vol_cargado }}
                        </td>
                        <td class="text-right">
                          {{ formatNumber(resultado.temperatura_carga, 3) }}
                        </td>
                        <!-- Datos de Laboratorio -->
                        <td class="text-right">
                          {{ formatNumber(resultado.agua_laboratorio, 2) }}
                        </td>
                        <td class="text-right">
                          {{ formatNumber(resultado.densidad_laboratorio, 3) }}
                        </td>
                        <td class="text-right">
                          {{
                            formatNumber(resultado.temperatura_laboratorio, 3)
                          }}
                        </td>
                        <td class="text-right">
                          {{ formatNumber(resultado.salinidad_laboratorio, 3) }}
                        </td>
                        <!-- Datos Adicionales -->
                        <td class="text-center">-</td>
                        <td class="text-center">-</td>
                        <!-- Resultados Calculados -->
                        <td class="text-right font-weight-bold text-success">
                          {{ resultado.vol_oil_hidratado_seco }}
                        </td>
                        <td class="text-right">
                          {{ formatNumber(resultado.temperatura_carga, 3) }}
                        </td>
                        <td class="text-right font-weight-bold text-primary">
                          {{ formatNumber(resultado.factor_correccion, 4) }}
                        </td>
                        <td class="text-right text-danger">
                          {{ resultado.vol_agua_sedimento }}
                        </td>
                        <td
                          class="text-right font-weight-bold text-success"
                          style="background-color: #d4edda"
                        >
                          {{ formatNumber(resultado.vol_total_final_seco, 3) }}
                        </td>
                        <td class="text-right">
                          {{ formatNumber(resultado.gravedad_api, 2) }}
                        </td>
                        <!-- Volumen Másico -->
                        <td class="text-right font-weight-bold">
                          {{ formatNumber(resultado.vol_inicial, 3) }}
                        </td>
                        <td class="text-right font-weight-bold">
                          {{ formatNumber(resultado.vol_final, 3) }}
                        </td>
                        <td
                          class="text-right font-weight-bold text-success"
                          style="background-color: #d4edda"
                        >
                          {{
                            formatNumber(
                              parseFloat(resultado.vol_final || 0) -
                                parseFloat(resultado.vol_inicial || 0),
                              3,
                            )
                          }}
                        </td>
                        <!-- Acciones -->
                        <td class="text-center">
                          <div class="d-flex justify-content-center">
                            <button
                              class="btn btn-success btn-xs mr-1"
                              @click="generarRemito(resultado)"
                              title="Generar Remito"
                            >
                              <i class="fas fa-file-pdf"></i>
                            </button>
                            <button
                              class="btn btn-danger btn-xs"
                              @click="eliminarResultado(index)"
                              title="Eliminar"
                            >
                              <i class="fas fa-trash"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!-- Modal Asignar Remitos por Rol -->
            <div
              class="modal fade"
              id="modalAsignarRemitos"
              tabindex="-1"
              role="dialog"
            >
              <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                  <div class="modal-header bg-primary text-white">
                    <h5 class="modal-title">
                      <i class="fas fa-user-tag mr-2"></i>
                      Asignar Remitos por Rol
                    </h5>
                    <button
                      type="button"
                      class="close text-white"
                      @click="cerrarModalAsignarRemitos()"
                    >
                      <span>&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <div class="form-group">
                      <label class="font-weight-bold">
                        <i class="fas fa-user-shield mr-1"></i>
                        Rol
                        <span class="text-danger">*</span>
                      </label>
                      <v-select
                        v-model="formularioAsignacion.rol"
                        placeholder="Seleccione un rol..."
                        label="name"
                        class="style-chooser"
                        :options="roles"
                      >
                        <template #option="option">
                          <div>
                            <i class="fas fa-shield-alt mr-2 text-primary"></i>
                            {{ option.name }}
                          </div>
                        </template>
                      </v-select>
                      <small class="text-muted">
                        Seleccione el rol al que desea asignar la cantidad de
                        remitos
                      </small>
                    </div>

                    <div class="form-group">
                      <label class="font-weight-bold">
                        <i class="fas fa-hashtag mr-1"></i>
                        Cantidad de Remitos
                        <span class="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        class="form-control"
                        v-model.number="formularioAsignacion.cantidad_remitos"
                        placeholder="Ingrese la cantidad de remitos"
                        min="1"
                      />
                      <small class="text-muted">
                        Cantidad máxima de remitos que el rol puede generar
                      </small>
                    </div>

                    <div class="alert alert-info mb-0">
                      <i class="fas fa-info-circle mr-2"></i>
                      <strong>Nota:</strong> Esta asignación establecerá un
                      límite de remitos que los usuarios con el rol seleccionado
                      podrán generar.
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      @click="cerrarModalAsignarRemitos()"
                    >
                      <i class="fas fa-times mr-1"></i>
                      Cancelar
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary"
                      @click="guardarAsignacionRemitos()"
                      :disabled="
                        !formularioAsignacion.rol ||
                          !formularioAsignacion.cantidad_remitos
                      "
                    >
                      <i class="fas fa-save mr-1"></i>
                      Guardar Asignación
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <SeguimientoCargueExcel ref="seguimientoCargueExcel" />
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Loading from "../../../../components/Loading";
import SeguimientoCargueExcel from "./SeguimientoCargueExcel.vue";
export default {
  name: "ControlCargueIndex",
  components: {
    Loading,
    vSelect,
    SeguimientoCargueExcel,
  },
  data() {
    return {
      cargando: false,
      clientes: [],
      transportes: [],
      conductores: [],
      remitos: [],
      sitios: [],
      hojasCarga: [],
      roles: [],
      formulario: {
        fecha_ini: null,
        hora_ini: null,
        fecha_fin: null,
        hora_fin: null,
        fecha: null,
        hoja_carga_id: null,
        hora_inicial: null,
        hora_final: null,
        cliente: null,
        transporte: null,
        conductor: null,
        documento: null,
        hoja_carga: null,
        numero_carga: null,
        remito: null,
        sitio: null,
        vol_cargado: 0,
        vol_oil_hidratado: 0,
        temp_tk_mas: 0,
        porcentaje_agua: 0,
        densidad: 0,
        t_muestra: 0,
        volumen_inicial: 0,
        volumen_final: 0,
      },
      formularioAsignacion: {
        rol: null,
        cantidad_remitos: null,
      },
      resultados: [],
    };
  },
  computed: {
    volumenCargadoM3() {
      // Calcular volumen cargado como la resta: Volumen Final - Volumen Inicial
      const inicial = parseFloat(this.formulario.volumen_inicial || 0);
      const final = parseFloat(this.formulario.volumen_final || 0);
      return (final - inicial).toFixed(3);
    },
  },
  mounted() {
    this.cargarClientes();
    this.cargarTransportes();
    this.cargarConductores();
    this.cargarRemitos();
    this.cargarSitios();
    this.$refs.seguimientoCargueExcel.getInstalaciones();
    //this.cargarRoles();
    this.formulario.fecha = new Date().toISOString().split("T")[0];
  },
  methods: {
    async cargarClientes() {
      try {
        const response = await axios.get("/api/argentina/clientes/lista", {
          params: { pais_id: 3 },
        });
        this.clientes = response.data;
      } catch (error) {
        console.error("Error al cargar clientes:", error);
        console.error("Detalles del error:", error.response);
        this.$swal({
          icon: "error",
          title: "Error al cargar clientes",
          text:
            error.response?.data?.message ||
            "No se pudieron cargar los clientes",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      }
    },

    async cargarTransportes() {
      try {
        const response = await axios.get("/api/argentina/empresas/lista", {
          params: { pais_id: 3 },
        });
        this.transportes = response.data;
      } catch (error) {
        console.error("Error al cargar transportes:", error);
      }
    },

    async cargarConductores() {
      try {
        const response = await axios.get("/api/argentina/choferes/lista", {
          params: { pais_id: 3 },
        });
        this.conductores = response.data;
      } catch (error) {
        console.error("Error al cargar conductores:", error);
      }
    },

    async cargarRemitos() {
      try {
        const response = await axios.get("/api/argentina/remitos", {
          params: { estado: 1 }, // Solo remitos disponibles
        });
        this.remitos = response.data.data || response.data;
      } catch (error) {
        console.error("Error al cargar remitos:", error);
      }
    },

    async cargarSitios() {
      try {
        const response = await axios.get("/api/admin/sitios/lista", {
          params: { pais_id: 3 },
        });
        this.sitios = response.data;
      } catch (error) {
        console.error("Error al cargar sitios:", error);
        this.$swal({
          icon: "error",
          title: "Error al cargar los sitios",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      }
    },

    async cargarHojasCarga(search, loading) {
      if (search != "") {
        let self = this;
        loading(true);
        var url = "/api/argentina/hojasCarga/lista?remito=" + search;
        axios
          .get(url)
          .then((response) => {
            self.hojasCarga = response.data;
            loading(false);
          })
          .catch((error) => {
            self.$swal({
              icon: "error",
              title: "Ocurrió un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            loading(false);
          });
      }
    },

    labelHojaCarga(hojaCarga) {
      if (!hojaCarga) return "";
      return `Remito N° ${hojaCarga.remito.numero ||
        "S/N"} - ${hojaCarga.fecha || "S/F"}`;
    },

    onHojaCargaChange() {
      // Autocompletar campos cuando se selecciona una hoja de carga
      if (this.formulario.hoja_carga) {
        const hoja = this.formulario.hoja_carga;

        // Autocompletar datos básicos
        this.formulario.hoja_carga_id = hoja.id;
        this.formulario.fecha = hoja.fecha || this.formulario.fecha;
        this.formulario.hora_inicial = hoja.hora_inicio || null;
        this.formulario.hora_final = hoja.hora_final || null;
        this.formulario.numero_carga = hoja.numero_interno || null;

        // Autocompletar cliente
        if (hoja.cliente) {
          this.formulario.cliente =
            this.clientes.find((c) => c.id === hoja.cliente_id) || hoja.cliente;
        }

        // Autocompletar transporte (empresa)
        if (hoja.empresa) {
          this.formulario.transporte =
            this.transportes.find((t) => t.id === hoja.empresa_id) ||
            hoja.empresa;
        }

        // Autocompletar conductor
        if (hoja.chofer) {
          this.formulario.conductor =
            this.conductores.find((c) => c.id === hoja.chofer_id) ||
            hoja.chofer;
          this.formulario.documento = hoja.chofer.numero_documento || "";
        }

        // Autocompletar remito
        if (hoja.remito) {
          this.formulario.remito =
            this.remitos.find((r) => r.id === hoja.remito_id) || hoja.remito;
        }

        // Autocompletar sitio (isla)
        if (hoja.isla) {
          this.formulario.sitio =
            this.sitios.find((s) => s.id === hoja.isla_id) || hoja.isla;
        }

        // Autocompletar datos de laboratorio y volúmenes
        this.formulario.vol_cargado = hoja.vol_cargado || 0;
        this.formulario.vol_oil_hidratado = hoja.vol_cargado || 0; // Usar vol_cargado como inicial
        this.formulario.temp_tk_mas = hoja.temperatura_carga || 0;
        this.formulario.porcentaje_agua = hoja.agua_laboratorio || 0;
        this.formulario.densidad =
          hoja.densidad_laboratorio || hoja.densidad || 0;
        this.formulario.t_muestra = hoja.temperatura_laboratorio || 0;
        this.formulario.volumen_inicial = hoja.vol_inicial || 0;
        this.formulario.volumen_final = hoja.vol_final || 0;

        this.$swal({
          icon: "success",
          title: "Información cargada desde la hoja de carga",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
      }
    },

    onConductorChange() {
      // Llenar automáticamente el documento cuando se selecciona un conductor
      if (this.formulario.conductor) {
        this.formulario.documento =
          this.formulario.conductor.numero_documento ||
          this.formulario.conductor.documento ||
          this.formulario.conductor.cedula ||
          "";
      } else {
        this.formulario.documento = "";
      }
    },

    onVolCargadoChange() {
      // Copiar automáticamente el volumen cargado al volumen oil hidratado
      this.formulario.vol_oil_hidratado = this.formulario.vol_cargado || 0;
    },

    labelConductor(conductor) {
      // Crear etiqueta para mostrar el nombre completo del conductor
      if (!conductor) return "";

      const nombre =
        conductor.nombre_completo ||
        `${conductor.nombres || ""} ${conductor.apellidos || ""}`.trim() ||
        `${conductor.primer_nombre || ""} ${conductor.segundo_nombre ||
          ""} ${conductor.primer_apellido || ""} ${conductor.segundo_apellido ||
          ""}`.trim() ||
        conductor.nombre ||
        "Sin nombre";

      return nombre;
    },

    buscarConductor(option, label, search) {
      // Función personalizada para filtrar por nombre o documento
      const searchLower = search.toLowerCase();

      // Buscar por nombre
      const nombre = this.labelConductor(option).toLowerCase();
      if (nombre.includes(searchLower)) return true;

      // Buscar por documento
      const documento = (
        option.numero_documento ||
        option.documento ||
        option.cedula ||
        ""
      ).toString();
      if (documento.includes(searchLower)) return true;

      return false;
    },

    async calcular() {
      // Validar campos obligatorios
      if (!this.formulario.sitio) {
        this.$swal({
          icon: "warning",
          title: "Por favor seleccione un sitio",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return;
      }

      // Validar campos numéricos requeridos
      if (
        !this.formulario.vol_cargado ||
        !this.formulario.densidad ||
        !this.formulario.temp_tk_mas
      ) {
        this.$swal({
          icon: "warning",
          title: "Complete Vol. Cargado, Densidad y Temperatura",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return;
      }

      this.cargando = true;

      try {
        // Llamar al backend para hacer los cálculos ASTM
        const response = await axios.post(
          "/api/argentina/control-cargues/calcular",
          {
            vol_cargado: this.formulario.vol_cargado,
            temp_tk_mas: this.formulario.temp_tk_mas,
            densidad: this.formulario.densidad,
            t_muestra: this.formulario.t_muestra,
            porcentaje_agua: this.formulario.porcentaje_agua,
            volumen_inicial: this.formulario.volumen_inicial,
            hoja_carga_id: this.formulario.hoja_carga_id,
          },
        );

        // Crear resultado con los datos del formulario + cálculos del backend
        const resultado = {
          ...this.formulario,
          ...response.data.resultados,
        };

        const hojaId = this.formulario.hoja_carga_id;
        if (hojaId != null && hojaId !== "") {
          const idxExistente = this.resultados.findIndex(
            (r) =>
              r.hoja_carga_id != null &&
              String(r.hoja_carga_id) === String(hojaId),
          );
          if (idxExistente !== -1) {
            this.$set(this.resultados, idxExistente, resultado);
          } else {
            this.resultados.push(resultado);
          }
        } else {
          this.resultados.push(resultado);
        }

        this.$swal({
          icon: "success",
          title: `Cálculo ${this.formulario.sitio.nombre} realizado exitosamente`,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });

        // Opcional: Limpiar algunos campos después de calcular
        // this.limpiarFormulario();
      } catch (error) {
        console.error("Error al calcular:", error);
        this.$swal({
          icon: "error",
          title:
            error.response?.data?.message || "Error al realizar los cálculos",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      } finally {
        this.cargando = false;
      }
    },

    eliminarResultado(index) {
      this.$swal({
        title: "¿Estás seguro?",
        text: "Se eliminará este resultado",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.resultados.splice(index, 1);
          this.$swal({
            icon: "success",
            title: "Resultado eliminado",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
          });
        }
      });
    },

    limpiarFormulario() {
      this.formulario = {
        fecha: new Date().toISOString().split("T")[0],
        hora_inicial: null,
        hora_final: null,
        cliente: null,
        transporte: null,
        conductor: null,
        documento: null,
        hoja_carga: null,
        numero_carga: null,
        remito: null,
        sitio: null,
        vol_cargado: 0,
        vol_oil_hidratado: 0,
        temp_tk_mas: 0,
        porcentaje_agua: 0,
        densidad: 0,
        t_muestra: 0,
        volumen_inicial: 0,
        volumen_final: 0,
      };
    },

    async guardarTodos() {
      if (this.resultados.length === 0) {
        this.$swal({
          icon: "warning",
          title: "No hay resultados para guardar",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return;
      }

      this.cargando = true;
      try {
        const response = await axios.post("/api/argentina/control-cargues", {
          resultados: this.resultados,
        });

        this.$swal({
          icon: "success",
          title: "Los datos se guardaron exitosamente",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });

        this.resultados = [];
        this.limpiarFormulario();
      } catch (error) {
        this.$swal({
          icon: "error",
          title: "Error al guardar los datos",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        console.error(error);
      } finally {
        this.cargando = false;
      }
    },

    formatNumber(value, decimals) {
      if (value === null || value === undefined || value === "") return "-";
      const num = parseFloat(value);
      if (isNaN(num)) return "-";
      return num.toFixed(decimals);
    },

    async generarRemito(resultado) {
      try {
        this.cargando = true;

        // Llamar al backend para generar el PDF
        const response = await axios.post(
          "/api/argentina/control-cargues/generar-remito",
          resultado,
          {
            responseType: "blob", // Importante para recibir el PDF
          },
        );

        // Crear un link para descargar el PDF
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;

        // Nombre del archivo con fecha y remito
        const nombreArchivo = `Remito_${
          resultado.remito ? resultado.remito.numero_formateado : "SN"
        }_${resultado.fecha}.pdf`;
        link.setAttribute("download", nombreArchivo);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.$swal({
          icon: "success",
          title: "Remito generado exitosamente",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
      } catch (error) {
        console.error("Error al generar remito:", error);
        this.$swal({
          icon: "error",
          title: "Error al generar el remito",
          text: error.response?.data?.message || "Intente nuevamente",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      } finally {
        this.cargando = false;
      }
    },

    /* async cargarRoles() {
      try {
        const response = await axios.get("/api/admin/roles");
        this.roles = response.data;
      } catch (error) {
        console.error("Error al cargar roles:", error);
        this.$swal({
          icon: "error",
          title: "Error al cargar los roles",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      }
    }, */

    abrirModalAsignarRemitos() {
      this.formularioAsignacion = {
        rol: null,
        cantidad_remitos: null,
      };
      const modal = document.getElementById("modalAsignarRemitos");
      if (modal) {
        window.$(modal).modal("show");
      }
    },

    cerrarModalAsignarRemitos() {
      const modal = document.getElementById("modalAsignarRemitos");
      if (modal) {
        window.$(modal).modal("hide");
      }
      this.formularioAsignacion = {
        rol: null,
        cantidad_remitos: null,
      };
    },

    async guardarAsignacionRemitos() {
      // Validar campos
      if (!this.formularioAsignacion.rol) {
        this.$swal({
          icon: "warning",
          title: "Por favor seleccione un rol",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return;
      }

      if (
        !this.formularioAsignacion.cantidad_remitos ||
        this.formularioAsignacion.cantidad_remitos < 1
      ) {
        this.$swal({
          icon: "warning",
          title: "Ingrese una cantidad válida de remitos",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return;
      }

      this.cargando = true;
      try {
        const response = await axios.post(
          "/api/argentina/control-cargues/asignar-remitos",
          {
            rol_id: this.formularioAsignacion.rol.id,
            rol_nombre: this.formularioAsignacion.rol.name,
            cantidad_remitos: this.formularioAsignacion.cantidad_remitos,
          },
        );

        this.$swal({
          icon: "success",
          title: "Asignación guardada exitosamente",
          text: `Se asignaron ${this.formularioAsignacion.cantidad_remitos} remitos al rol ${this.formularioAsignacion.rol.name}`,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });

        this.cerrarModalAsignarRemitos();
      } catch (error) {
        console.error("Error al guardar asignación:", error);
        this.$swal({
          icon: "error",
          title: "Error al guardar la asignación",
          text: error.response?.data?.message || "Intente nuevamente",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      } finally {
        this.cargando = false;
      }
    },

    async buscar() {
      this.cargando = true;

      try {
        // Llamar al backend para hacer los cálculos ASTM
        const response = await axios.get(
          "/api/argentina/control-cargues/buscar-hojas-carga",
          {
            params: {
              fecha_ini: this.formulario.fecha_ini,
              fecha_fin: this.formulario.fecha_fin,
              hora_ini: this.formulario.hora_ini,
              hora_fin: this.formulario.hora_fin,
            },
          },
        );
        console.log(response.data);
        this.resultados = response.data;

        this.$swal({
          icon: "success",
          title: `Se realizo la busqueda de las hojas de carga exitosamente`,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });

        // Opcional: Limpiar algunos campos después de calcular
        // this.limpiarFormulario();
      } catch (error) {
        console.error("Error al calcular:", error);
        this.$swal({
          icon: "error",
          title:
            error.response?.data?.message || "Error al realizar los cálculos",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      } finally {
        this.cargando = false;
      }
    },
  },
};
</script>

<style scoped>
/* Botones de minimizar en la esquina superior derecha del card */
.card-header.position-relative .card-tools,
.card-header.card-header-corner .card-tools {
  position: absolute;
  right: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  margin: 0;
}

.card-header.card-header-corner .card-title {
  padding-right: 2.5rem;
}

.card {
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.125), 0 1px 3px rgba(0, 0, 0, 0.2);
}

.card-outline {
  border-top: 3px solid;
}

.card-outline.card-info {
  border-top-color: #17a2b8;
}

.card-outline.card-primary {
  border-top-color: #007bff;
}

.card-outline.card-success {
  border-top-color: #28a745;
}

.card-outline.card-warning {
  border-top-color: #ffc107;
}

.form-group {
  margin-bottom: 0.5rem;
}

.form-group label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #495057;
}

.form-control:focus {
  border-color: #28a745;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}

/* Estilos para v-select más compacto */
.style-chooser >>> .vs__dropdown-toggle {
  padding: 0.25rem 0.5rem;
  min-height: 31px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.style-chooser >>> .vs__search {
  padding: 0;
  margin: 0;
  font-size: 0.875rem;
}

.style-chooser >>> .vs__selected {
  font-size: 0.875rem;
  padding: 0;
  margin: 2px 0;
}

.style-chooser >>> .vs__actions {
  padding: 0 3px;
}

.style-chooser >>> .vs__clear,
.style-chooser >>> .vs__open-indicator {
  fill: #6c757d;
}

.style-chooser >>> .vs__dropdown-option {
  padding: 5px 10px;
  font-size: 0.875rem;
}

.style-chooser >>> .vs__dropdown-menu {
  max-height: 250px;
}

/* Contenedor de tabla con scroll mejorado */
.table-container {
  max-height: 600px;
  overflow: auto;
  position: relative;
  border-radius: 0.25rem;
  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.05);
}

/* Tabla personalizada */
.custom-table {
  margin-bottom: 0;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 0.85rem;
  width: 100%;
}

.custom-table thead th {
  vertical-align: middle;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.6rem 0.5rem;
  border: 1px solid #dee2e6;
  white-space: nowrap;
  background-color: #f8f9fa;
  color: #495057;
  position: sticky;
  top: 0;
  z-index: 5;
}

.custom-table thead th[colspan] {
  font-size: 0.8rem;
  font-weight: 700;
  padding: 0.7rem 0.5rem;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.custom-table tbody td {
  vertical-align: middle;
  font-size: 0.8rem;
  padding: 0.5rem;
  border: 1px solid #e9ecef;
  background-color: white;
  min-width: 90px;
}

.custom-table tbody tr:hover td {
  background-color: #f1f3f5;
}

/* Columna fija (sticky) */
.sticky-col {
  position: sticky;
  left: 0;
  z-index: 3;
  background-color: #f8f9fa !important;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  font-weight: 600;
  min-width: 100px !important;
}

.custom-table tbody tr:hover .sticky-col {
  background-color: #e9ecef !important;
}

/* Colores suaves para encabezados de sección */
.header-carga {
  background-color: #d1ecf1 !important;
  color: #0c5460 !important;
}

.header-laboratorio {
  background-color: #fff3cd !important;
  color: #856404 !important;
}

.header-resultado {
  background-color: #d4edda !important;
  color: #155724 !important;
}

.header-masico {
  background-color: #d6e9f8 !important;
  color: #004085 !important;
  font-weight: 700 !important;
}

/* Resaltar celdas importantes */
.font-weight-bold {
  font-weight: 700;
}

.text-success {
  color: #28a745 !important;
}

.text-primary {
  color: #007bff !important;
}

.text-danger {
  color: #dc3545 !important;
}

/* Scrollbar mejorado */
.table-container::-webkit-scrollbar {
  height: 10px;
  width: 10px;
}

.table-container::-webkit-scrollbar-track {
  background: #f1f3f5;
  border-radius: 10px;
}

.table-container::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #adb5bd, #868e96);
  border-radius: 10px;
  border: 2px solid #f1f3f5;
}

.table-container::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #868e96, #6c757d);
}

.table-container::-webkit-scrollbar-corner {
  background: #f1f3f5;
}

/* Badge mejorado */
.badge {
  padding: 0.35em 0.65em;
  font-size: 0.8rem;
  font-weight: 600;
}

/* Botón de acción */
.btn-xs {
  padding: 0.15rem 0.4rem;
  font-size: 0.75rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

/* Estilos para el modal de asignación */
.modal-header.bg-primary {
  background-color: #007bff !important;
}

.modal-body .alert-info {
  background-color: #e7f3ff;
  border-color: #b8daff;
  color: #004085;
  border-radius: 0.25rem;
  padding: 0.75rem 1rem;
}

.modal-body .form-group label {
  font-size: 0.9rem;
  color: #495057;
}

.modal-body .form-group small {
  display: block;
  margin-top: 0.25rem;
  font-size: 0.8rem;
}

.modal-dialog-centered {
  min-height: calc(100% - 1rem);
}
</style>
